import styled, { css } from 'styled-components'
import { P } from 'konsys-ui'
import Banner from '../../images/quotation-request/banner.jpg'
import PrintingBanner from '../../images/printing-information/banner.jpg'
import DesignServiceBanner from '../../images/home/Design_Service_Background.jpg'
import { theme, media, minMedia } from '../../styles/_variables'

const Wrapper = styled.div`
  padding: 56px 16px;
  ${media.tablet`
    padding: 40px 16px;
  `}
`

export const QuotationRequestSection = styled.div`
  padding: 56px 16px;
  background-image: url(${Banner});
  background-size: cover;
  background-position: center center;
  ${media.tablet`
    padding: 40px 16px;
    > h1 {
      font-size: ${theme.fonts.size.subHeading};
    }
  `}
  ${media.mobileS`
    h1 {
      font-size: ${theme.fonts.size.title};
    }
  `}
`

export const PrintingImage = styled.div`
  width: 136px;
  height: 136px;
  border-radius: 50%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${props => props.bg});
    background-size: cover;
    background-position: center center;
    transition: all 0.5s ease;
  }
  &:hover {
    &:before {
      transform: scale(1.2);
    }
  }
  ${media.tablet`
    width: 112px;
    height: 112px;
  `}
  ${media.tabletS`
    width: 136px;
    height: 136px;
  `}
`

export const PrintingTechnique = styled.div`
  padding: 48px 16px;
  background-image: url(${PrintingBanner});
  background-size: cover;
  background-position: center center;
  ${media.tablet`
    padding: 32px 0px;
  `}
  > div {
    > h4 {
      ${media.tablet`
        font-size: ${theme.fonts.size.subTitle};
      `}
    }
    > div {
      ${media.tablet`
        text-align: left;
        > div {
          display: flex;
          > *:not(:nth-child(5)) {
            flex-basis: 25%;
          }
        }
      `}
      ${media.tabletS`
        > div > *:not(:nth-child(5)) {
          flex-basis: 50%;
        }
      `}
    }
  }
`

export const PrintingMachineImg = styled.img`
  width: 100%;
`

export const Line = styled.hr`
  border-top: 3px solid ${theme.color.secondaryColor};
  position: absolute;
  top: 24px;
  left: 0;
  right: 0;
  ${media.tablet`
    border-top: 2px solid ${theme.color.secondaryColor};
    top: 16px;
    right: -16px;
  `}
`

export const PrintingMachineWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 56px 0;
  ${media.tabletS`
    padding: 40px 0;
    flex-direction: column;
  `}
  h3 {
    font-size: ${theme.fonts.size.subTitle};
  }
`

export const BlueBoxImg = styled(PrintingMachineImg)``

export const DesignServiceWrapper = styled(Wrapper)`
  position: relative;
  ${minMedia.tablet`
    background-image: url(${DesignServiceBanner});
    background-size: cover;
    background-position: center center;
    background-attachment: fixed;
  `}

  ${media.tablet`
    padding-left: 0;
    padding-right: 0;
    &::after {
      content: '';
      position: fixed;
      top: 0;
      bottom: 0;
      background-image: url(${DesignServiceBanner});
      background-size: auto 100vh;
      background-position: 50% 30% !important;
      width: 100vw;
      z-index: -3;
    }
  `}
  h2 {
    font-size: ${theme.fonts.size.subTitle};
    &.second-title {
      font-size: ${theme.fonts.size.title};
    }
  }
  ${media.mobileS`
    h2 {
      font-size: ${theme.fonts.size.extraNormal};
      &.second-title {
        font-size: ${theme.fonts.size.subTitle};
      }
    }
  `}
`

export const IconImg = styled(PrintingMachineImg)``
export const WhiteBoxImg = styled(PrintingMachineImg)``

export const WhatWeDoWrapper = styled(Wrapper)`
  background-color: ${theme.color.offWhite};
  .text {
    color: ${theme.color.lightGrey};
  }
  ${media.tablet`
    padding-left: 0;
    padding-right: 0;
    h1 {
      font-size: ${theme.fonts.size.subHeading};
    }
    h4 {
      font-size: ${theme.fonts.size.extraNormal};
      font-weight: 600;
      &.text {
        font-size: ${theme.fonts.size.normal};
        font-weight: 400;
      }
    }
  `}
  ${media.mobileS`
    h1 {
      font-size: ${theme.fonts.size.title}
    }
  `}
`

export const PortFolioImgBg = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  right: 12px;
  bottom: 12px;
  transition: all 0.5s ease;
  transform: scale(1.1);
  ${props => props.img && css`
    background-image: url(${props.img});
    background-size: cover;
    background-position: center;
  `}
`

export const PortFolioImageWrapper = styled.div`
  width: 252px;
  height: 252px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${props => props.img});
    background-size: cover;
    background-position: center center;
    transition: all 0.5s ease;
    z-index: 2;
  }
  &:after {
    content: '';
    position: absolute;
    top: 16px;
    bottom: 16px;
    left: 16px;
    right: 16px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    opacity: 0;
    transition: all 0.5s ease;
    z-index: 3;
  }
  > i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 32px;
    color: rgba(255, 255, 255, 0.8);
    opacity: 0;
    transition: all 0.5s ease;
    z-index: 3;
  }
  &:hover {
    &:before {
      background-color: rgba(0, 0, 0, 0.5);
    }
    &:after {
      opacity: 1;
    }
    > ${PortFolioImgBg} {
      transform: scale(1.2);
    }
    > i {
      opacity: 1;
    }
  }
  ${media.tabletS`
    width: calc((100vw - 56px) / 2);
    height: calc((100vw - 56px) / 2);
  `}
`

export const PortFolioWrapper = styled(Wrapper)`
  text-align: center;
  padding: 56px 72px;
  background-color: ${theme.color.offWhite};
  position: relative;
  > a,
  > p {
    margin: 24px 0 0;
  }
  ${media.tablet`
    padding: 40px 16px 64px;
    text-align: left;
    .slick-prev,
    .slick-next {
      display: none !important;
    }
    > a,
    > p {
      position: absolute;
      top: 40px;
      right: 16px;
    }
  `}
  ${media.mobileS`
    h2 {
      font-size: ${theme.fonts.size.title}
    }
  `}
`

export const PackagingWrapper = styled(Wrapper)`
  text-align: left;
  padding: 56px 72px;
  background-color: ${theme.color.offWhite};
  position: relative;
  .link-see-all,
  > p {
    margin: 24px 0 0;
  }
  ${media.tablet`
    padding: 40px 16px 64px;
    text-align: left;
    .slick-prev,
    .slick-next {
      display: none !important;
    }
    .link-see-all,
    > p {
      position: absolute;
      top: 40px;
      right: 16px;
    }
  `}
`
export const PackageWidthContainer = styled.div`
  ${minMedia.laptop`
    width: 100%;
    max-width: ${theme.maxWidth};
    margin-left: 50%;
    transform: translateX(-50%);
    padding: 0 16px;
    padding: ${props => (props.padding ? props.padding : '0 16px')};
    ${props => props.bgColor && css`
      background-color: ${props.bgColor};
    `}
    ${minMedia.laptopXL`
      max-width: 59vw;
    `}
    ${media.tablet`
      width: 100%;
      max-width: 100%;
    `}
  `}
  ${media.mobileS`
    h2{
      font-size: ${theme.fonts.size.title}
    }
  `}
`

export const DivPackage = styled.div`
  padding: 8px;
  & {
    > div {
      height: fit-content;
      -webkit-transition-duration: 400ms;
      transition-duration: 400ms;
      transition-delay: 50ms;
      box-shadow: 0 4px 10px rgb(0 0 0 / 8%), 0 4px 4px rgb(0 0 0 / 4%);
    }
  }
  &:hover {
    > div {
      transform: scale(1.03);
      transition-property: all;
      transition-duration: 400ms;
      transition-delay: 50ms;
      transition-timing-function: ease;
      box-shadow: 0 4px 10px rgb(0 0 0 / 6%), 0 4px 4px rgb(0 0 0 / 4%);
    }
  }
`

export const DivPackageDefault = styled.div`
  width: calc((100%) / 4);
  padding: 8px;
  ${media.tablet`
    width: calc((100%) / 3);
  `}
  ${media.tabletS`
    width: calc((100%) / 2);
  `}
  & {
    > div {
      -webkit-transition-duration: 400ms;
      transition-duration: 400ms;
      transition-delay: 50ms;
      box-shadow: 0 4px 12px rgb(0 0 0 / 12%), 0 4px 4px rgb(0 0 0 / 4%);
    }
  }
  &:hover {
    > div {
      transform: scale(1.02);
      transition-property: all;
      transition-duration: 400ms;
      transition-delay: 50ms;
      transition-timing-function: ease;
      filter: drop-shadow(0 5px 8px rgb(0 0 0 / 0.03)) drop-shadow(0 4px 4px rgb(0 0 0 / 0.18));
    }
  }
`

export const BannerWrapper = styled.div`
  background-color: ${theme.color.offWhite};
  position: relative;
  ${media.tablet`
    .slick-prev,
    .slick-next {
      display: none !important;
    }
    .slick-dots {
      position: absolute;
      bottom: 8px;
      > li button:before {
        width: 8px;
        height: 8px;
      }
    }
  `}
`

export const PopupContainerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
`

export const PopupWrapper = styled.div`
  border-radius: 0;
  background-color: white;
  max-height: 80vh;
  max-width: 500px;
  margin: 32px;
  overflow: auto;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
  position: relative;
  > img {
    width: 100%;
  }
  > i {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
`

export const ArrowTextWrapper = styled.div`
  transition: all 1s ease;
  &.slick-disabled {
    > p {
      display: none;
    }
  }
  &:hover {
    > p {
      font-weight: 600;
    }
  }
`

export const ArrowIconWrapper = styled.div`
  transition: all 1s ease;
  .fa {
    font-weight: 400 !important;
  }
  &:hover {
    > i {
      color: ${theme.color.lightGrey}
    }
  }
`

export const LinkText = styled(P)`
  ${media.mobileM`
    font-size: ${theme.fonts.size.small}
  `}
  transition: all ease-in-out 1s;
  position: relative;
  text-decoration: none !important;
  &:after {
    content: '';
    width: 0;
    height: 1px;
    display: block;
    transition: all .5s ease;
    background-color: ${theme.color.primaryColor};
    position: absolute;
    right: 0;
    bottom: 0;
  }
  &:hover {
    &:after {
      width: 55px;
    }
  }
  &:active {
    color: ${theme.color.tertiaryColor};
    &:after {
      width: 55px;
      background-color: ${theme.color.tertiaryColor};
    }
  }
`

export default QuotationRequestSection



// WEBPACK FOOTER //
// ./src/pages/home/styled.js